import type { ModuleNav } from '@saas/ui';

export const WIKI_READ = 'wiki.page.read';
export const WIKI_WRITE = 'wiki.page.write';
export const WIKI_MANAGE = 'wiki.page.manage';
export const WIKI_SPACE_MANAGE = 'wiki.space.manage';
export const WIKI_ADMIN_ROLES = ['owner', 'admin'];

/** apps/web のシェルが集約する。登録はリードが行う（apps/web/src/app/shell/nav.ts） */
export const wikiNav: ModuleNav = {
  module: 'wiki',
  items: [
    { label: 'マニュアル', to: '/manual', icon: 'description', end: true, description: '社内の手順・ルール', newWindow: true },
    { label: 'マニュアルを探す', to: '/wiki/search', icon: 'search', description: '本文から探す' },
    { label: 'レビュー期限', to: '/wiki/reviews', icon: 'schedule', permission: [WIKI_WRITE], description: 'まだ正しいかの確認' },
  ],
  admin: [],
};
